import { apiFetch, apiFetchBlob } from './client.js';

/** Reports → Transactions (DEV-129). Amounts are integer minor-unit strings. */

export type ReportCurrency = 'EUR' | 'USD' | 'CAD';
export type ReportType = 'SEPA' | 'SEPA_INSTANT' | 'SWIFT' | 'INTERNAL' | 'FEE';
export type ReportStatus = 'COMPLETED' | 'PROCESSING' | 'REJECTED' | 'RETURNED' | 'UNATTRIBUTED' | 'EVIDENCE_ONLY';
export type ReportProvider = 'GURUPAY' | 'BANKERA' | 'MANUAL' | 'NORVIX';
export type ReportFlow = 'B2B' | 'B2C' | 'C2B' | 'C2C' | 'UNKNOWN';
/** Export file format (DEV-148). */
export type ReportExportFormat = 'xlsx' | 'csv';
export type FeeSource = 'STANDARD' | 'INDIVIDUAL' | 'EDITED' | 'UNKNOWN' | 'NONE';

export interface TransactionReportRow {
  id: string;
  source: 'INBOUND' | 'OUTBOUND' | 'FEE';
  createdAt: string;
  executedAt: string | null;
  providerReference: string;
  type: ReportType;
  direction: 'IN' | 'OUT';
  flow: ReportFlow | null;
  amountMinor: string;
  currency: string;
  reportingMinor: string | null;
  rateDate: string | null;
  rateSource: string;
  customerId: string | null;
  customerName: string;
  customerType: 'B' | 'C' | 'UNKNOWN';
  counterpartyName: string;
  counterpartyAccount: string;
  counterpartyBank: string;
  counterpartyBic: string;
  counterpartyCountry: string;
  provider: ReportProvider;
  customerAccount: string;
  paymentReference: string;
  status: ReportStatus;
  rawStatus: string;
  feeName: string;
  feeMinor: string | null;
  feeReportingMinor: string | null;
  feeRate: string;
  feeSource: FeeSource;
  feeScheduleVersion: number | null;
  feeRefunded: boolean;
}

export interface ReportTotals {
  count: number;
  turnoverMinor: string | null;
  feeMinor: string | null;
  /** Commissions on completed payments only: the effective rate's numerator. */
  paymentFeeMinor: string | null;
  missingRates: number;
}
export interface GroupTotals extends ReportTotals { key: string; label: string }

export interface TransactionReport {
  /** YYYY-MM-DD, inclusive, UTC. */
  from: string;
  through: string;
  reportingCurrency: ReportCurrency;
  totals: ReportTotals;
  byCustomer: GroupTotals[];
  byProvider: GroupTotals[];
  rows: TransactionReportRow[];
  totalRows: number;
  page: number;
  pageSize: number;
  loadedAt: string;
}

export const reportTransactionsApi = {
  read: (query: string): Promise<TransactionReport> => apiFetch(`/admin/reports/transactions?${query}`),
  export: (query: string, format: ReportExportFormat): Promise<Blob> =>
    apiFetchBlob(`/admin/reports/transactions/export?${query}&format=${format}`),
};
